module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb-bar', {
    attrs: {
      "crumbs": []
    }
  }, [_c('ul', {
    staticClass: "page-breadcrumb",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Reports Index',
        params: {
          reset: true
        }
      }
    }
  }, [_c('span', {
    staticClass: "gold"
  }, [_vm._v("Reports")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Top 5 Reports List'
      }
    }
  }, [_vm._v("Top 5 Reports")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "form-body",
    class: {
      loading: _vm.loading.list
    }
  }, [(_vm.loading.list) ? _c('vue-spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vgt-responsive"
  }, [_c('table', {
    staticClass: "vgt-table bordered"
  }, [_c('thead', [_c('tr', [_vm._l((_vm.columns), function(col) {
    return _c('th', {
      class: {
        'cell-actions': col.field === 'action',
        'sorting': col.field !== 'action'
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.sort(col.field)
        }
      }
    }, [_vm._v(_vm._s(col.label))])])
  }), _vm._v(" "), _vm._m(1)], 2), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "filter-th"
  }, [_c('div', [_c('input', {
    staticClass: "vgt-input",
    attrs: {
      "type": "text",
      "placeholder": "Filter Name"
    },
    on: {
      "change": function($event) {
        return _vm.filter('name', $event)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "filter-th"
  }, [_c('div', [_c('input', {
    staticClass: "vgt-input",
    attrs: {
      "type": "text",
      "placeholder": "Filter Description"
    },
    on: {
      "change": function($event) {
        return _vm.filter('description', $event)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "filter-th"
  }), _vm._v(" "), _c('th', {
    staticClass: "filter-th"
  }, [_c('div', [_c('input', {
    staticClass: "vgt-input",
    attrs: {
      "type": "text",
      "placeholder": "Filter Created By"
    },
    on: {
      "change": function($event) {
        return _vm.filter('user', $event)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "filter-th"
  }), _vm._v(" "), _c('th', {
    staticClass: "filter-th"
  }), _vm._v(" "), _c('th', {
    staticClass: "filter-th"
  }), _vm._v(" "), _c('th', {
    staticClass: "filter-th"
  })])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "folder"
  }, [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Reports Index',
        params: {
          reset: true
        }
      },
      "tag": "a"
    }
  }, [_c('i', {
    staticClass: "fa fa-level-up dark"
  }), _vm._v(" ... ")])], 1)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row) {
    return (_vm.reports.length) ? _c('tr', {
      staticClass: "item"
    }, [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Reports Preview',
          params: {
            reportid: row.id
          }
        },
        "tag": "a"
      }
    }, [_vm._v(_vm._s(row.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.description))]), _vm._v(" "), _c('td', {
      staticClass: "vgt-text-nowrap"
    }, [_vm._v(_vm._s(row.mode == 2 ? 'Multiple Organizations' : 'Single Organization'))]), _vm._v(" "), _c('td', {
      staticClass: "vgt-text-nowrap"
    }, [_vm._v(_vm._s(row.user))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(row.created_date.date)))]), _vm._v(" "), _c('td', [(row.modified_date !== null) ? [_vm._v(_vm._s(_vm._f("formatDate")(row.modified_date.date)))] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s((row.status == 1) ? 'Published' : 'Unpublished'))]), _vm._v(" "), _c('td', {
      staticClass: "cell-action"
    }, [_c('div', {
      staticClass: "last-dropdown"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_vm._m(2, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu",
      attrs: {
        "role": "menu"
      }
    }, [(_vm.user.access > 3) ? _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Reports Edit',
          params: {
            reportid: row.id
          }
        },
        "tag": "a"
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    }), _vm._v(" Edit\n                                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.access > 3) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeStatusAction(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" Publish / Draft ")])]) : _vm._e(), _vm._v(" "), (_vm.user.access > 3) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showDuplicateModal(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-files-o"
    }), _vm._v(" Duplicate ")])]) : _vm._e(), _vm._v(" "), (_vm.user.access > 3) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showMoveToFolderModal('report', row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrows"
    }), _vm._v(" Move ")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.exportReport(row.id, row.count)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-o"
    }), _vm._v(" Export\n                                ")])]), _vm._v(" "), (_vm.user.access > 3) ? _c('li', {
      staticClass: "divider"
    }) : _vm._e(), _vm._v(" "), (_vm.user.access > 3) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showDeleteReportModal(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete\n                                ")])]) : _vm._e()])])])]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "mt-checkbox mt-checkbox-outline"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "disabled": _vm.topReportsIds.length >= 5 && !_vm.topReportsIds.includes(row.id)
      },
      domProps: {
        "value": row.id,
        "checked": _vm.topReportsIds.includes(row.id)
      },
      on: {
        "change": function($event) {
          $event.preventDefault();
          return _vm.selectTopReport(row.id)
        }
      }
    }), _vm._v(" "), _c('span')])])]) : _vm._e()
  }), 0)])])], 1), _vm._v(" "), _c('button', {
    staticClass: "save-top-reports btn green pull-right",
    on: {
      "click": _vm.saveTopReports
    }
  }, [_vm._v("Save Top 5 Reports")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "duplicate-report-modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "d-report"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('d-report.name')
    }
  }, [_c('label', {
    attrs: {
      "for": "formname"
    }
  }, [_vm._v("Report Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "formname",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('d-report.name')),
      expression: "errors.has('d-report.name')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('d-report.name')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('d-report.description')
    }
  }, [_c('label', {
    attrs: {
      "for": "formdesc"
    }
  }, [_vm._v("Report Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "formdesc",
      "name": "description",
      "type": "text"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('d-report.description')),
      expression: "errors.has('d-report.description')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('d-report.description')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button duplicate-report-modal-btn",
    attrs: {
      "data-style": "expand-left"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitDuplicate.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Duplicate Report")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "delete-report-modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button remove-participant-control",
    attrs: {
      "data-dismiss": "modal",
      "data-style": "expand-left"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteReportAction(_vm.currentModal)
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "move-to-folder-modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('vue-select', {
    attrs: {
      "options": _vm.accountFolders,
      "label": "name",
      "value": "id",
      "multiple": false,
      "placeholder": "Select folder"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._l((option.lvl), function(idx) {
          return (option.lvl > 1) ? [_vm._v("  ")] : _vm._e()
        }), _vm._v("\n                " + _vm._s(option.name) + "\n              ")]
      }
    }]),
    model: {
      value: (_vm.moveToFolderId),
      callback: function($$v) {
        _vm.moveToFolderId = $$v
      },
      expression: "moveToFolderId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button remove-participant-control",
    attrs: {
      "data-dismiss": "modal",
      "data-style": "expand-left"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.moveToFolderAction({
          'itemType': _vm.currentModal.type,
          'itemId': _vm.currentModal.id,
          'folderId': _vm.moveToFolderId.id
        })
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("OK")])]), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), (_vm.showExportModal) ? _c('export-modal', {
    attrs: {
      "report-id": _vm.exportReportId,
      "result-total-rows": _vm.exportTotalRows
    },
    on: {
      "display": function($event) {
        _vm.showExportModal = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('i', {
    staticClass: "icon-globe theme-font hide"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("Top 5 Reports")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Top 5"), _c('br'), _vm._v("Reports")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-xs green dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    }
  }, [_vm._v(" Actions\n                              "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Duplicate Report")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("DELETE REPORT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v("Are you sure you would like to delete this Report?")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("MOVE TO FOLDER")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f3356d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reports/ReportsTop5List.vue
// module id = 1693
// module chunks = 1